import { gql } from '@apollo/client';

export const listCategories = gql`
  query listCategories($pagination: PaginationInput) {
    listCategories(pagination: $pagination) {
      id
      name {
        languageCode
        value
      }
      ordinal
    }
  }
`;

export const listExperts = gql`
  query listExperts($pagination: PaginationInput) {
    listExperts(pagination: $pagination) {
      id
      firstName
      lastName
    }
  }
`;
